import { Injectable } from '@angular/core';
import { AlertModel } from '../models/AlertModel';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  selfClosingAlerts: AlertModel[] = [];
  stickyAlerts: AlertModel[] = [];

  addSticky(alert: AlertModel): void {
    this.stickyAlerts.push(alert);
  }

  addSelfClosing(alert: AlertModel): void {
    if (!alert.id) {
      alert.id = Date.now() + Math.random();
    }
    this.selfClosingAlerts.push(alert);

    setTimeout((alertToClose) => {
      console.log(`Closing alertId ${alert.id}`);
      this.selfClosingAlerts = this.selfClosingAlerts.filter(obj => alertToClose.id !== obj.id);
    }, 3000, alert);
  }

  closeSelfClosing(alert: AlertModel): void {
    this.selfClosingAlerts.splice(this.selfClosingAlerts.indexOf(alert), 1);
  }

  closeSticky(alert: AlertModel): void {
    this.stickyAlerts.splice(this.stickyAlerts.indexOf(alert), 1);
  }
}
